/*
 * Media this client asked for (a captured image, a recording it stopped). The server's answer reaches every client of the user; `mediaArrived` tells listeners only when the item was this client's, with the dock panel that lists it.
 */
const pending = new Set()
const listeners = new Set()

const key = (panel, id) => `${panel}:${id}`

export const expectMedia = (panel, id) => pending.add(key(panel, id))

export function mediaArrived(panel, id) {
	if (!pending.delete(key(panel, id))) return
	for (const fn of listeners) fn(panel, id)
}

/** Every item of this client's that arrived; returns the unsubscribe. */
export function onOwnMediaArrived(fn) {
	listeners.add(fn)
	return () => listeners.delete(fn)
}
